import { render, staticRenderFns } from "./sizetable.vue?vue&type=template&id=f7f6da42&scoped=true"
import script from "./sizetable.vue?vue&type=script&lang=js"
export * from "./sizetable.vue?vue&type=script&lang=js"
import style0 from "./sizetable.vue?vue&type=style&index=0&id=f7f6da42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f6da42",
  null
  
)

export default component.exports